import { ColDef, ValueGetterParams } from "ag-grid-community";
import { ResourceType } from "@/services/cloudchipr.api";
import {
  listingPriceFrequencyKeyForLocalContext,
  ResourceListingPriceHeaderComponent,
} from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/listing-price/ResourceListingPriceHeaderComponent";
import { ResourceListingPriceCellRenderer } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/listing-price/ResourceListingPriceCellRenderer";
import { money } from "@/utils/numeral/money";

export const listingPriceColumnDefField = "resource.listing_price.monthly";

export const getListingPriceColumnDef = (
  resourceType: ResourceType,
): ColDef => ({
  field: listingPriceColumnDefField,
  minWidth: 280,
  width: 300,
  headerName: "Listing Price",
  headerTooltip:
    "Prices are calculated based on the public pricing terms of each resource, such as On-Demand usage.",
  headerComponentParams: {
    innerHeaderComponent: ResourceListingPriceHeaderComponent,
    innerHeaderComponentParams: { resourceType },
  },
  valueGetter: (props) => {
    return money(filterValueGetter(props));
  },
  filterValueGetter,
  cellRenderer: ResourceListingPriceCellRenderer,
});

const filterValueGetter = ({ data, ...props }: ValueGetterParams) => {
  const listingPrice = data?.resource?.listing_price;

  const frequency =
    props?.column?.getColDef().context?.[
      listingPriceFrequencyKeyForLocalContext
    ];

  return +(listingPrice?.[frequency ?? "monthly"] ?? listingPrice?.monthly);
};
